import { Store, useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import {
    StringSingleSelectionSlideIn,
    Option,
} from '../../ui/slidein/SingleSelectionSlideIn.tsx';
import * as MetaState from '../../common/state/MetaState.ts';
import { Translation } from '../../common/i18n/Text.ts';
import * as AdditionalAddressEditSlideInText from '../i18n/AdditionalAddressEditSlideInText.ts';
import * as AddressState from '../state/AddressState.ts';
import * as PermitCreateState from '../state/PermitCreateState.ts';
import { thenElse, getOrElse } from 'dg-web-shared/lib/MaybeV2.ts';

export interface Texts {
    Heading: Translation;
    Caption: Translation;
}

export const setAddressCountry = (store: Store, country: string) => {
    AddressState.Edit.writeAddress(store, { country: country });
    AddressState.Edit.stateWrite(store, { selectAddressCountryOpen: false });
    return 'AddressCountrySelectionSlideIn-setCountry';
};

export function AddressCountrySelectionSlideIn({
    onSelect,
    onLeftActionClick,
    open,
}: {
    onSelect: (v: string) => void;
    onLeftActionClick: () => void;
    open: boolean;
}) {
    const { storeState } = useStore(store => ({
        countries: MetaState.AddressCountries.get(store),
        edit: AddressState.Edit.get(store),
        config: PermitCreateState.Config.get(store),
    }));
    const { language } = useLanguage();

    const txt = AdditionalAddressEditSlideInText.countrySelection[language];

    const options: Option<string>[] = storeState.countries.data.map(
        (t: MetaState.AddressCountry) => {
            return {
                id: t.id,
                displayText: `${t.id} — ${t.name[language]}`,
            };
        },
    );

    const defaultCountry = 'CH';
    const selection = getOrElse(
        storeState.edit.address.country,
        thenElse(
            storeState.config.address,
            c => getOrElse(c.country, defaultCountry),
            defaultCountry,
        ),
    );
    return (
        <StringSingleSelectionSlideIn
            open={open}
            heading={txt.Heading()}
            selection={selection}
            options={options}
            onSelect={onSelect}
            onLeftActionClick={onLeftActionClick}
            outsideBody
        />
    );
}
